import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../store';
import { CalendarScaleType, CalendarViewType } from '../types';

const useControlCarousel = (carouselRef: React.MutableRefObject<any>) => {
    const viewCalendar = useSelector<RootState, CalendarViewType>((state) => state.calendar.viewCalendar);
    const scheduleScale = useSelector<RootState, CalendarScaleType>((state) => state.calendar.scheduleScale);

    const getNumberSlide = () => {
        switch (viewCalendar) {
            case 'schedule':
                switch (scheduleScale) {
                    case 'day':
                        return 0;
                    case 'week':
                        return 1;
                    case 'month':
                        return 2;
                    default:
                        return 0;
                }
            // case 'year': return 3;
            case 'agenda':
                return 3;
            // case 'table':
            case 'list':
                return 4;
            default:
                return 0;
        }
    };

    useEffect(() => {
        const newCurrentSlide = getNumberSlide();
        carouselRef.current.goTo(newCurrentSlide);
    }, [viewCalendar, scheduleScale]);
};

export default useControlCarousel;
